import { render, staticRenderFns } from "./CoalitionForces.vue?vue&type=template&id=3b4bb336&scoped=true"
import script from "./CoalitionForces.vue?vue&type=script&lang=js"
export * from "./CoalitionForces.vue?vue&type=script&lang=js"
import style0 from "./CoalitionForces.vue?vue&type=style&index=0&id=3b4bb336&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4bb336",
  null
  
)

export default component.exports